<template>
  <div
    class="marquee"
    :class="[`is-${color}`, { 'is-tilted': tilted }]"
  >
    <div class="marquee__track">
      <span
        v-for="n in 2"
        :key="n"
        class="marquee__group"
        :aria-hidden="n === 2"
      >
        <span
          v-for="(token, i) in tokens"
          :key="i"
          class="marquee__item"
        >{{ token }}<span class="marquee__sep"> - </span></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeBand',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'yellow' // yellow | red
    },
    tilted: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // un « groupe » doit dépasser la largeur du plus grand écran pour que la
    // boucle (2 groupes, translate -50%) reste sans trou : on répète assez le contenu
    tokens() {
      const base = this.items.length ? this.items : [this.text]
      const out = []
      const copies = this.items.length ? 3 : 6
      for (let c = 0; c < copies; c++) out.push(...base)
      return out
    }
  }
}
</script>

<style lang="scss" scoped>
.marquee {
  overflow: hidden;
  padding: 14px 0;

  &.is-yellow {
    background: $yellow;
    color: $navy;
  }

  &.is-red {
    background: $red;
    color: $white;
  }

  &.is-tilted {
    transform: rotate(-1.1deg) scaleX(1.02);
  }
}

.marquee__track {
  display: flex;
  width: max-content;
  animation: marquee-scroll 40s linear infinite;
}

.marquee__group {
  display: flex;
  white-space: nowrap;
}

.marquee__item {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.marquee__sep {
  padding: 0 10px;
}

@keyframes marquee-scroll {
  to {
    transform: translateX(-50%);
  }
}

@include mobile {
  .marquee__item {
    font-size: 14px;
  }
}
</style>
